<template>
    <div class="pb-4">
        <template v-if="!formresponse_data">
            <div class="skeleton midnight h32 w-50 rounded mt-4 mb-3"></div>
            <div class="mt-4">
              <div v-for="item in Array(7)" v-bind:key="item">
                  <div class="skeleton midnight h32 w-100 rounded mb-3"></div>
              </div>
            </div>
        </template>
        <template v-if="formresponse_data && !done">
            <div class="float-right">
                <button class="btn btn-success mb-2 ml-2" v-if="showCompleteBtn"
                    @click="formresponse.formresponse_completed = 1; saveFormResponse()">{{ $t('submit-form') }}
                </button>
            </div>
            <div class="clearfix d-inline-block align-top">
                <h2 class="mb-0">
                    <template v-if="formresponse_data.title">
                        {{ formresponse_data.title }}
                    </template>
                </h2>
                <p class="mb-4">
                    <template v-if="formresponse.savedreport">
                        {{ formresponse.savedreport.inputs.savedreport_title }}
                    </template>
                    <template v-if="formresponse.user_id != $UserSession.getValue('id')">
                        {{ $t('user-colon') }} <strong>{{ formresponse.user_displayname }}</strong>
                        <template v-if="formresponse.usersignoff_displayname">
                            <br>
                        </template>
                    </template>
                </p>
            </div>

            <p v-if="formresponse.formresponse_message" style="white-space: pre-wrap" class="mt-0 mb-4">
                {{ formresponse.formresponse_message }}
            </p>
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>{{ $t("date-time") }}</label>
                        <input type="datetime-local" v-model="formresponse.datetime" class="form-control"
                        />
                    </div>
                </div>
            </div>

            <template v-if="(formresponse_data.navigation == 'sidebar')">
                <TabbedView @done="saveFormResponse" @hasNextChanged="hasNextUpdater">
                    <TabbedViewTab v-for="(page, pageIndex) in filteredPages" :title="page.title" :id="pageIndex.toString()"
                        :key="pageIndex">
                        <FormGrid :page="page" :formresponse="formresponse"
                            :readonly="!canEdit || !userCanCompletePage(page)" :viewAs="role"></FormGrid>
                    </TabbedViewTab>
                </TabbedView>
            </template>
            <template v-else>
                <template v-for="(page, pageIndex) in filteredPages">
                    <div class="card mb-8" :key="pageIndex" v-if="pageNum == pageIndex + 1">
                        <div class="card-body">
                            <h2 class="card-title" v-if="page.title">{{ page.title }}</h2>
                            <FormGrid :page="page" :formresponse="formresponse"
                                :readonly="!canEdit || !userCanCompletePage(page)" :viewAs="role"></FormGrid>
                        </div>
                    </div>
                </template>
                <div class="clearfix mb-3">
                    <button class="btn btn-secondary" v-if="showPreviousPageBtn" @click="previousPage">{{
                        $t('previous-page') }}</button>
                    <button class="btn btn-primary ml-2" v-if="showNextPageBtn" @click="nextPage">{{ $t('next-page')
                    }}</button>
                </div>
            </template>

            <div class="clearfix mb-3">
                <div class="float-right">
                    <button class="btn btn-success mb-2 ml-2" v-if="showCompleteBtn"
                        @click="formresponse.formresponse_completed = 1; saveFormResponse()">
                        {{ $t('submit-form') }}
                    </button>
                </div>
            </div>
        </template>
        <template v-if="done">
			<div class="row">
				<div class="col-12 mb-4">
					<div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
						<div class="card-body text-center">
							<b-icon icon="check-circle-fill" variant="success" font-scale="7.5" class="mb-2"></b-icon>
							<h5 class="card-title">{{ $t('thank-you') }}</h5>
							<p class="card-text">
								{{ $t('form-saved-extuser') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</template>
    </div>
</template>

<script>
import TabbedView from "src/components/TabbedView";
import TabbedViewTab from "src/components/TabbedViewTab";
import FormGrid from "src/components/FormEditor/FormGrid";

export default {
    components: {
        TabbedView,
        TabbedViewTab,
        FormGrid,
    },
    data: function () {
        return {
            formid: null,
            formresponse: {
                id: null,
                workflowstage_id: null,
                learningoutcomes: [],
                user_id: null,
                userfrom_id: null,
                usersubject_id: null,
                userreview_id: null,
                usersignofffrom_id: null,
                externaluser_id: null,
                datetime: null,
                workbooks: [],
                workflowstage: {},
                formresponse_data: null
            },
            static_url: {},
            loading : true,
            stage: null,
            pageNum: 1,
            loadingreportview: true,
            reportHtml: null,
            loadinghtmlreportview: true,
            individualReportHtml: null,
            currentreporttab: 0,
            subjects: [],
            reviewers: [],
            signers: [],
            viewAs: [],
            hasNext: false,
            requestSignoffActive: false,
            tabIndex: 0,
            externaluser: {},
            done: false
        }
    },
    methods: {
        nullPageValues(page) {
            for (let row of page.grid) {
                for (let col of row) {
                    for (let field of col.fields) {
                        field.value = null;
                    }
                }
            }
            return page;
        },
        fetchForm() {
			if (!this.$route.params.token) return Promise.resolve()

			this.$store.commit('showBlockingSpinner')

  			return this.$cfetch(`${this.$settings.APIBaseURL}/staticurls/access/?t=${this.$route.params.token}`)
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching stage')
                this.formresponse = {
                    id: null,
                    form_id: res.result.form_id,
                    user_id: null,
                    userfrom_id: null,
                    usersubject_id: null,
                    userreview_id: null,
                    usersignofffrom_id: null,
                    externaluser_id: null,
                    datetime: this.$datetime.getDateTimeLocalFieldNowValue(),
                    workbooks: [],
                    formresponse_data: res.result.formresponse_data
                }

			})
			.catch(error => {
                console.log(error)
				this.$log.error.call(this, error)
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-fetching-static-url'),
					confirmCallBack: function () {
						this.$router.push('/settings/static-url')
					}
				})
			})
			.finally(() => {
				this.$store.commit('hideBlockingSpinner')
			})
    	},
        nextPage() {
            if (this.pageNum < this.filteredPages.length) {
                this.pageNum++
            }
        },
        previousPage() {
            if (this.pageNum > 1) {
                this.pageNum--;
            }
        },
        formSubmitFailed() {
            this.$store.commit("openDialog", {
                title: this.$t("oops"),
                content: this.$t("form-save-failed"),
                confirmCallBack: function () {
                }
            });

        },
        formSubmitSuccess() {
            const self = this;
            this.$store.commit("openDialog", {
                title: self.$t("saved"),
                content: self.$t("form-saved"),
                confirmCallBack: function () {
                    self.done = true;
                }
            });
        },
        saveFormResponse(silent = false) {
            this.$store.commit("showBlockingSpinner");

            if (this.formresponse.datetime) {
                this.formresponse.formresponse_dateofresponse = this.$datetime.getTimeStampFromDateTimeField(
                    this.formresponse.datetime
                );
            }

            /*if(this.formresponse.usersignofffrom_id){
                this.formresponse.externaluser_id = null;
            } else {
                this.formresponse.usersignofffrom_id = null;
            }*/

            this.$cfetch(`${this.$settings.APIBaseURL}/staticurls/form/response/save/`, {
                method: 'post',
                data: {
                    formresponse: this.formresponse,
                    t: this.$route.params.token
                }
            }).then(res => {
                if (silent) return;
                if (res.status === "SUCCESS") {

                    //this.formSubmitSuccess();
                    this.done = true;
                } else {
                    // something went wrong
                    this.formSubmitFailed();
                }
            }).catch(error => {
                this.$log.error.call(this, error);
                this.formSubmitFailed();
            }).finally(() => {
                this.$store.commit("hideBlockingSpinner");
            })
        },
        unableToOpenFormResponse() {
            const self = this;
            this.$store.commit("openDialog", {
                title: this.$t('oops'),
                content: this.$t('unable-to-open-form'),
                confirmCallBack: function () {
                    self.$router.replace('/forms');
                }
            });
        },
        userCanCompletePage(page) {
            var viewAs = this.role;
            return !('permission' in page) || page.permission.length === 0 || page.permission.includes(viewAs) || viewAs == 'editall'
        },
        userCanViewPage(page) {
            return !page.hideifcantcomplete || this.userCanCompletePage(page) || (page.showaftersignoff && this.formresponse && this.formresponse.formresponse_signedoff == '1');
        },
        hasNextUpdater(data) {
            this.hasNext = true;
            this.hasNext = data;
            return data;
        },
    },
    computed: {
        isSignedOff() {
            return this.formresponse.formresponse_signedoff == '1';
        },
        filteredPages() {
            const pages = [];
            if (this.formresponse_data) {
                for (let page of this.formresponse_data.pages) {
                    if (this.userCanViewPage(page)) {
                        pages.push(page);
                    }
                }
            }
            return pages;
        },
        showNextPageBtn() {
            return this.formresponse_data && this.formresponse_data.next && this.pageNum < this.filteredPages.length;
        },
        showPreviousPageBtn() {
            return this.formresponse_data && this.formresponse_data.previous && this.pageNum > 1;
        },
        isTeacher() {
            return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
        },
        canEdit() {
            return /*this.isTeacher || */!this.isSignedOff;
        },
        showCompleteBtn() {
            return (this.role == 'submitter' || this.role == 'editall') && (!this.formresponse.workflowstage || Number(this.formresponse.workflowstage.requiresignoff) == 0)
        },
        formresponse_id() {
            return this.formresponse ? this.formresponse.formresponse_id : null;
        },
        formresponse_data() {
            return this.formresponse ? this.formresponse.formresponse_data : null;
        },
        role() {
            return 'submitter';
        },
    },
    mounted() {
        this.fetchForm().then(() => {
			this.loading = false
		})
    }
}
</script>
